import {useAppDispatch} from "../../hooks";
import React, {useCallback, useEffect} from "react";
import {SIGN_SUCCESS} from "../../actions/sign";
import {sign as diiaSign} from "../../actions/diia";
import styles from "../../styles/Popup/Popup.module.css";
import {QRCodeSVG} from "qrcode.react";
import Popup from "./Popup";
import {CircularProgress} from "@mui/material";
import MediaQuery from "react-responsive";
import { Btn } from '../../styles/Button.styled';


export function DiiaSignPopup(props: DiiaProps) {
    const dispatch = useAppDispatch();

    const closePopup = useCallback((e) => {
        e.preventDefault();
        if (props.clickCloseButton) {
          props.clickCloseButton();
        }
      });
    
    useEffect(() => {
        if (props.diia.sign.state === "success") {
            dispatch({
                type: SIGN_SUCCESS,
                payload: props.diia.sign,
            });
        } else {
            const timer = setTimeout(() => {
                dispatch(diiaSign(props.diia.requestId, props.diia.docs));
            }, 3000);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [props.diia]);

    return (
        <Popup
            clickCloseButton={props.clickCloseButton}
            className={props.className}
        >
            <MediaQuery maxWidth={767}>
                <h1>Підписання через Дію</h1>
                <h2>Оберіть один із двох запропонованих варіантів</h2>
                <div className={styles.variant}>
                    <div className={styles.numbers}>1</div>
                    <h3>
                        Натисніть кнопку <span>“Підписати”</span>, якщо Дія встановлена на
                        цьому пристрої
                    </h3>
                </div>
                <a
                    className={styles.button}
                    href={props.diia.deeplink}
                    target="_blank"
                    rel="noreferrer"
                >
                    Підписати
                </a>
                <div className={styles.divider}/>

                <div className={styles.variant}>
                    <div className={styles.numbers}>2</div>
                    <h3>
                        Відкрийте Дію та натисніть на кнопку <span>&quot;Дія Сканер&quot;</span>
                    </h3>
                </div>

                <div className={`${styles.qr} ${styles.qr_withBtn}`}>
                    {props.diia.state === "loading" ? (
                        <CircularProgress
                            size={124}
                            sx={{
                                color: "var(--dark-gray)",
                            }}
                        />
                    ) : (
                        <>
                            {props.diia.deeplink === undefined ? (
                                <p>На жаль, не можливо згенерувати QR, спробуйте пізніше</p>
                            ) : (
                                <QRCodeSVG value={props.diia.deeplink} size="171"/>
                            )}
                        </>
                    )}
                </div>
            </MediaQuery>

            <MediaQuery minWidth={768}>
                <h1 style={{marginBottom: '20px'}}>Підписання через застосунок Дія</h1>
                {props.diia.deeplink !== undefined && (
                    <p>Відкрийте Дію та натисніть на кнопку &quot;Дія Сканер&quot;</p>
                )}

                <div className={`${styles.qr} ${styles.qr_withBtn}`}>
                    {props.diia.state === "loading" ? (
                        <CircularProgress
                            size={124}
                            sx={{
                                color: "var(--dark-gray)",
                            }}
                        />
                    ) : (
                        <a href={props.diia.deeplink} target="_blank" rel="noreferrer">
                            {props.diia.deeplink === undefined ? (
                                <p>На жаль, не можливо згенерувати QR, спробуйте пізніше</p>
                            ) : (
                                <QRCodeSVG value={props.diia.deeplink} size="256"/>
                            )}
                        </a>
                    )}
                </div>
                <div  style={{position:"absolute", bottom:"20px",width:"100%", paddingRight:"40px"}}>
                    <Btn
                        type="button"
                        $width="100%"
                        $color="var(--blue)"
                        $marginTop="0"
                        onClick={()=>closePopup()}
                        $background='var(--sidebar-hover)'
                        >
                        Відмінити
                    </Btn>
                </div>
            </MediaQuery>
        </Popup>
    );
}
